export default {
    NOT_AVAILABLE: "k.A",
    ONLINE: "ONLINE",
    OFFLINE: "OFFLINE",
    OK: "OK",
    DANGER: "ACHTUNG",
    WARNING: "WARNUNG",
    BOOK_IT: "Buche es"
};